import Honeybadger from "@honeybadger-io/js"

const config: Parameters<typeof Honeybadger.configure>[0] = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_STAGE,
  revision: import.meta.env.VITE_GIT_COMMIT_ID
}

export const honeybadger = Honeybadger.configure(config)
